const getToppingNameOrEmpty = (optionId, toppings) =>
  toppings[optionId]?.toppingName || "";

const getSideNameOrEmpty = (optionId, sides) => sides[optionId]?.sideName || "";

export const getOptionNameOrEmpty = (optionId, isTopping, toppings, sides) => {
  if (optionId) {
    return isTopping
      ? getToppingNameOrEmpty(optionId, toppings)
      : getSideNameOrEmpty(optionId, sides);
  }
  return "";
};
